import http_request from './http_request'
import config from 'config'

function getDesmos(id) {
	return http_request.get(config.api + 'desmos/' + id)
		.send()
}

function getResults(mode='initial') {
	return http_request.get(config.api + 'desmos/graphs')
		.send({
			mode,
		})
}

function saveDesmos(id, categoryId, pickId) {
	return http_request.put(config.api + 'desmos/' + id)
		.send({
			categoryId,
			pickId,
		})
}

export default {
	getDesmos,
	getResults,
	saveDesmos,
}
